import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { Envelope, Pen, Person, Plus, Telephone, ChatLeftDots } from 'react-bootstrap-icons'
import ClientContactModal from './ClientContactModal'

export default observer(function ClientContacts({
  clientContacts,
  addToClientContacts,
  updateClientContacts,
  deleteClientContact
}) {

  const [clientContactModalOpen, setClientContactModalOpen] = useState(false)
  const [edit, setEdit] = useState(false)
  const [editableContact, setEditableContact] = useState()
  const [index, setIndex] = useState()
  const [hover, setHover] = useState(false);


  const openNewClientContactModal = () => {
    setEditableContact()
    setEdit(false)
    setIndex()
    setClientContactModalOpen(true)
  }

  const openEditClientContactModal = (clientContact, index) => () => {
    setEditableContact(clientContact)
    setEdit(true)
    setIndex(index)
    setClientContactModalOpen(true)
  }

  return (
    <div className='my-5'>
      <div className="flex justify-between items-center">
        <p className="font-bold text-md ">Client contacts</p>
        <button
          type="button"
          className="flex items-center bg-rb-green text-white p-1 px-3 rounded-md dark:text-rb-dark-mode"
          onClick={openNewClientContactModal}
        >
          <Plus />Add new
        </button>
      </div>

      <div className="overflow-y-scroll">
        {clientContacts.map((clientContact, index) => (
          <div key={index} className="grid grid-cols-12 my-4 items-center border-1 border-rb-widget-boarder rounded-lg p-3">
            <div className="col-span-1">
              {clientContact.avatar && <img className="h-12 w-12 rounded-2xl" src={URL.createObjectURL(clientContact.avatar)} /> || <div className="h-12 w-12 bg-rb-green rounded-2xl text-white flex items-center justify-center border-1 border-white"><Person /></div>}
            </div>
            <div className="pl-4 col-span-10">
              <p className="text-sm font-bold">{clientContact.name}</p>
              <div className="flex items-center">
                <p className="text-sm flex items-center mr-4"> <span className="text-rb-green mr-1"><Envelope /></span> <span>{clientContact.email}</span></p>
                <p className="text-sm flex items-center mr-4"><span className="text-rb-green mr-1"><Telephone /></span><span>{clientContact.phone}</span></p>
                {clientContact.notes && (
                  <ChatLeftDots
                    className='text-rb-green'
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                  />
                )
                }
              </div>
            </div>
            <button type="button" onClick={openEditClientContactModal(clientContact, index)} className="col-span-1 rounded-md hover:bg-gray-200 w-10 h-10 flex items-center justify-center mr-4"><Pen /></button>
          </div>
        ))}
      </div>
      {
        clientContactModalOpen && (
          <ClientContactModal
            isOpen={clientContactModalOpen}
            setIsOpen={setClientContactModalOpen}
            edit={edit}
            editableContact={editableContact}
            index={index}
            addToClientContacts={addToClientContacts}
            updateClientContacts={updateClientContacts}
            deleteClientContact={deleteClientContact}
          />
        )
      }
    </div>
  )
})


// className = "bg-white rounded-lg p-5 border-1 border-rb-widget-boarder h-72"
